/**
 * Einstieg bei zuletzt besuchter Seite
 *
 * @class service_v3sResumeService
 * @memberOf v3sWbtPlayerApp:helper
 */
angular.module('v3sWbtPlayerApp').factory('v3sResumeService', ['v3sWbtDataService', 'v3sNavigationService', 'v3sAlertService', 'v3sI18nService', 'v3sResumeConfig', function (v3sWbtDataService, v3sNavigationService, v3sAlertService, v3sI18nService, v3sResumeConfig) {
    var resumed = false;

    return {
        resume: function resume(scope) {
            if (!resumed && (v3sResumeConfig == 'always' || v3sResumeConfig == 'ask')) {
                resumed = true; // nur 1 mal prüfen

                var wbt = v3sWbtDataService.getWbt();
                var api = v3sWbtDataService.getScormApi();
                var entry = api.getEntry();
                var location = api.getLocation();
                var currentPage = v3sNavigationService.getCurrentPage();

                if (!entry && !!location && currentPage.getId() != location) {
                    var page = wbt.getItem(location);

                    if (!!page && page.isVisible() && !page.isLocked()) {
                        var sco = page.getSco();
                        var pageTitle = page.getTitle();
                        var chapterTitle = sco.getTitle();
                        var pageState = v3sNavigationService.getPageState(page);
                        var pageHref = v3sNavigationService.getHref(pageState);

                        if (!!pageState) {

                            if (v3sResumeConfig == 'always') {
                                v3sNavigationService.goTo(pageState);
                            } else {
                                var alertLastVisitMessage = function alertLastVisitMessage() {
                                    var message = v3sI18nService.getText("dialogs.location.message");
                                    var linkMessage;

                                    if (page.getId() != sco.getId()) {
                                        linkMessage = v3sI18nService.getText("dialogs.location.pageMessage", { pageTitle: pageTitle, chapterTitle: chapterTitle });
                                    } else {
                                        linkMessage = v3sI18nService.getText("dialogs.location.chapterMessage", { chapterTitle: chapterTitle });
                                    }

                                    var lastVisitMessage = "";
                                    var lastVisit = api.getLastVisit();
                                    if (lastVisit > 0) {
                                        lastVisitMessage = "<br />" + v3sI18nService.getText("dialogs.location.visitMessage", { date: v3sI18nService.getDate(lastVisit, "f") });
                                    }

                                    message += "<p><a href=" + pageHref + ">" + linkMessage + lastVisitMessage + "</a></p>";

                                    var resumeAlert = v3sAlertService({
                                        title: v3sI18nService.getText("dialogs.location.title"),
                                        content: message,
                                        html: true,
                                        placement: 'top-right-float',
                                        container: '#feedbacks',
                                        type: "resume",
                                        scope: scope
                                    });

                                    scope.$on('$destroy', function () {
                                        resumeAlert.hide();
                                    });
                                }

                                var loaded = v3sI18nService.loadLibrary();
                                if (loaded === true) {
                                    alertLastVisitMessage();
                                } else {
                                    loaded.then(function () {
                                        alertLastVisitMessage();
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}]);